module.exports = __webpack_public_path__ + "static/media/under_maintenance.0ce77855.svg";